import type { Me } from "../api";

/** Coins left, as a pill in the top bar (the free / ad split and the refill time are explained in the Token card). */
export function CoinBadge({ me }: { me: Me | null }) {
  if (!me) return <span className="coin-badge" aria-busy="true">…</span>;
  return (
    <span className="coin-badge" aria-label={`Còn ${me.total} token`}>
      <span className="coin-dot" aria-hidden="true" />
      {me.total} token
    </span>
  );
}

/** Render machine status: a dot only; the words are its tooltip and what screen readers hear. */
export function RenderStatus({ online }: { online: boolean | undefined }) {
  if (online === undefined) return null;
  const text = online ? "Máy xử lý sẵn sàng" : "Máy xử lý đang bận";
  return (
    <span className={`render-status ${online ? "is-online" : "is-offline"}`} title={text}>
      <span className="render-dot" aria-hidden="true" />
      <span className="visually-hidden">{text}</span>
    </span>
  );
}
